var map = {
	"./arrow_left.svg": 47,
	"./arrow_right.svg": 48,
	"./city_events.svg": 137,
	"./discord.svg": 138,
	"./instagram.svg": 139,
	"./medium.svg": 140,
	"./real_properties.svg": 141,
	"./real_reward.svg": 142,
	"./real_token.svg": 143,
	"./telegram.svg": 144,
	"./treasury.svg": 145,
	"./twitter.svg": 146,
	"./youtube.svg": 147
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 136;